/** Letters NFD does not decompose, and typographic apostrophes. */
const FOLDED_LETTERS: Record<string, string> = {
  œ: 'oe',
  æ: 'ae',
  ß: 'ss',
  ø: 'o',
  ł: 'l',
  đ: 'd',
  '\u2018': "'",
  '\u2019': "'",
  '\u02bc': "'",
};
const FOLDED_LETTER = new RegExp(`[${Object.keys(FOLDED_LETTERS).join('')}]`, 'g');

/**
 * Lowercase, accents and ligatures folded: « bresil » matches « Brésil »,
 * « coeur » « Cœur », « l'oreal » « L’Oréal ».
 */
export function normalizeSearch(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase()
    .replace(FOLDED_LETTER, (letter) => FOLDED_LETTERS[letter] ?? letter);
}

/** The normalized words of a search; empty for a blank search. */
export function searchWords(search: string): string[] {
  return normalizeSearch(search).split(/\s+/).filter(Boolean);
}

/** Normalized non-empty fields, to compute once per record. */
export function normalizeFields(fields: (string | null | undefined)[]): string[] {
  return fields
    .filter((field): field is string => !!field)
    .map(normalizeSearch);
}

/**
 * Every word must appear in one of the fields (already normalized), in any
 * order: « dupont hélène » finds Hélène Dupont. No word matches everything.
 */
export function matchesSearchWords(
  normalizedFields: string[],
  words: string[],
): boolean {
  return words.every((word) =>
    normalizedFields.some((field) => field.includes(word)),
  );
}
